// Display labels for roles, set in Admin → Branding Settings. Display only: role names stay the
// permission keys (e.g. 'Super Admin' checks), so compare/filter on the name and render roleLabel(name).
// BrandingProvider keeps this in sync.
let currentLabels = {};
try {
  const cached = JSON.parse(localStorage.getItem('gc_branding_cache_v1') || 'null');
  if (cached && cached.roleLabels && typeof cached.roleLabels === 'object') currentLabels = cached.roleLabels;
} catch {
  // ignore — no storage available
}

export function roleLabel(name) {
  if (!name) return name;
  return currentLabels[name] || name;
}

export function setRoleLabels(labels) {
  currentLabels = labels && typeof labels === 'object' ? labels : {};
}
